import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  questionGroup: css`
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-width: 360px) {
      gap: 6px;
    }
  `,
  answerInput: css`
    display: flex;
    gap: 8px;
    justify-content: space-between;
    flex-direction: column;
  `,
  questionHeader: css`
    display: flex;
    gap: 8px;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  `,
} satisfies Styles<void>;

export const useQuestionStyles = withStyles(styles);
